import { withErrorBoundary } from "@sentry/nextjs";
import cn from "classnames";
import { FC, ReactNode, UIEvent } from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import { useLockBodyScroll } from "hooks";

interface Props {
  isOpen: boolean;
  children: ReactNode;
  onRequestClose: () => void;
  bigSize?: boolean;
  // eslint-disable-next-line no-unused-vars
  onScroll?: (event: UIEvent<HTMLDivElement>) => void;
}

ReactModal.setAppElement("#modal-root");

export const Modal: FC<Props> = withErrorBoundary(
  ({ isOpen, children, onRequestClose, onScroll = () => {}, bigSize = false }) => {
    useLockBodyScroll(isOpen);

    return (
      <ReactModal
        className={cn("Modal", { "Modal_big-size": bigSize })}
        overlayClassName="Modal__overlay"
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        isOpen={isOpen}
        contentElement={(props, children) => (
          <StyledModal {...props} onScroll={onScroll}>
            {children}
          </StyledModal>
        )}
        overlayElement={(props, contentElement) => <StyledOverlay {...props}>{contentElement}</StyledOverlay>}
        onRequestClose={onRequestClose}
      >
        {children}
      </ReactModal>
    );
  },
  {}
);

const StyledOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgb(25 24 23 / 64%);
  z-index: 1000;
`;

const StyledModal = styled.div`
  width: 800px;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.colors.fog["00"]};
  overflow-y: auto;
  outline: none;
  border-radius: 8px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
`;
